import { render, staticRenderFns } from "./KnowledgeRestrictionCard.vue?vue&type=template&id=10e6de68&scoped=true&"
import script from "./KnowledgeRestrictionCard.vue?vue&type=script&lang=js&"
export * from "./KnowledgeRestrictionCard.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeRestrictionCard.vue?vue&type=style&index=0&id=10e6de68&prod&scoped=true&lang=css&"
import style1 from "./KnowledgeRestrictionCard.vue?vue&type=style&index=1&id=10e6de68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6de68",
  null
  
)

export default component.exports